import React, { ReactElement } from 'react'
import { IStepPropsPeriodique } from '../../interfaces/Step'
import Checkbox from '../formGroup/Checkbox'
import { preventEnterFormSubmit } from '../../services/utils'
import Step6FormHook from '../../hooks/Step6FormHook'
import SignatureErrorModal from '../Modal/SignatureErrorModal'
import ModalContainer from '../Modal/ModalContainer'

function Step6Form(props: IStepPropsPeriodique): ReactElement {
  const {
    form,
    onFormSubmit,
    validation_terms_and_conditions,
    modalOpen,
    setModalOpen,
  } = Step6FormHook(props)
  const { handleSubmit, register, errors } = form
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form
      onSubmit={handleSubmit(onFormSubmit)}
      onKeyPress={preventEnterFormSubmit}
    >
      <div className="card px4 pt4 pb3">
        <Checkbox
          label="J’atteste sur l’honneur l’exactitude des renseignements mentionnés ci-dessus"
          id="validation_terms_and_conditions"
          name="validation_terms_and_conditions"
          checked={validation_terms_and_conditions === '1' || false}
          register={register({ required: true })}
          error={errors.validation_terms_and_conditions}
          labelClassName="fontWeightBold fontSizeSm fontStyleIt"
          className="mb0"
        />
      </div>
      <ModalContainer isOpen={modalOpen}>
        <SignatureErrorModal
          onClose={() => setModalOpen(false)}
          title="Une erreur est survenue. Merci de réessayer."
        />
      </ModalContainer>
      <div className="pt5 textRight">
        <input
          type="hidden"
          name="document_type_signature"
          id="document_type_signature"
          value="10"
          ref={register}
        />
        <button
          data-testid="goToNextStepBtn"
          className="btn btnPrimary"
          type="submit"
        >
          Terminer
        </button>
      </div>
    </form>
  )
}

export default Step6Form
